



























































import { Component, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import EditDialog from './EditDialog.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { of } from 'rxjs'

@Component({
    components: {
        SearchForm,
        TableForm,
        EditDialog
    }
})
export default class extends Vue {
    tableData: any[] = []
    tableLoading: boolean = false
    total = 0

    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        userCode: null,
        email: null
    }
    formProp = {}
    editDialogVisible = false
    editDisable = false

    created(): void {
        this.getData()
    }

    getData(pageQuery = {}): void {
        Object.assign(this.searchForm, pageQuery)
        this.tableLoading = true
        of(null)
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(res => {
                console.log(res)
                this.tableData = [{
                    id: 234
                }]
                // this.tableData = res.records
                // this.total = res.total
            })
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    reset(formName): void {
        ;(this.$refs[formName] as Form).resetFields()
    }

    edit(row: any) {
        this.editDialogVisible = true
    }
}
